module.exports = __webpack_public_path__ + "img/dining@2x.a2c59aec.png";